import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIRequest } from '../../common/Common';
import { getAlertMessageFunction, handleRejected, sanitizeList } from '../../common/Util';

const initialState = {
  htmAlias: null,

  myInfo: null,

  reload: -1,

  originalAddressList: null,
  address: '',
};

//개인정보 가져옴
export const getInsaInfoLoad = createAsyncThunk('myInfo/getInsaInfoLoad', async () => {
  const response = await APIRequest('/YA/insaInfoLoad');
  return response;
});

//비밀번호 변경
export const changePassword = createAsyncThunk('myInfo/changePassword', async data => {
  const response = await APIRequest('/YA/changePassword', data);
  return response;
});

//내정보수정
export const changeMyInfo = createAsyncThunk('myInfo/changeMyInfo', async data => {
  const response = await APIRequest('/YA/changeMyInfo', data);
  return response;
});

//주소검색
export const getAddress = createAsyncThunk('myInfo/getAddress', async data => {
  console.log('getAddress 실행됨!!!!:', data);
  const response = await APIRequest(`/YA/Search${data.CMD}`, data.data);
  return response;
});

const myInfoSlice = createSlice({
  name: 'myInfo',
  initialState,
  reducers: {
    resetMyInfoState: state => {
      state = initialState;
    },
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    resetOriginalAddressList: (state, action) => {
      state.originalAddressList = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getInsaInfoLoad.fulfilled, (state, action) => {
      let data = sanitizeList([action.payload]);
      if (data.length > 0) {
        state.myInfo = data[0];
      }
    });
    builder.addCase(getAddress.fulfilled, (state, action) => {
      const remainingItems = action.payload.slice(1);

      // start 값이 1이면 새로운 검색이므로 리스트 초기화
      if (action.meta.arg.data.start === 1) {
        state.originalAddressList = remainingItems;
      } else {
        // 이후 페이지는 기존 리스트에 추가
        if (state.originalAddressList)
          state.originalAddressList = [...state.originalAddressList, ...remainingItems];
        else state.originalAddressList = remainingItems;
      }
    });

    builder.addCase(getAddress.rejected, (state, action) => {
      console.log('getAddress.rejected 실행됨!!!!:', action);
      state.originalAddressList = null;
    });
  },
});
export default myInfoSlice.reducer;
export const { resetMyInfoState, setReload, setAddress, resetOriginalAddressList } =
  myInfoSlice.actions;
